module.exports = __webpack_public_path__ + "img/faq-hero.40dda076.svg";